import { render, staticRenderFns } from "./MenuSnowflake.vue?vue&type=template&id=15f4ee6f&scoped=true"
import script from "./MenuSnowflake.vue?vue&type=script&lang=js"
export * from "./MenuSnowflake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4ee6f",
  null
  
)

export default component.exports